import React,{useEffect,useState} from "react";
import styles from "./ConfirmPage.module.css";
import { CheckCircle, Globe } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getTranslation as t } from '../Helpers/Translate';
import Loader from "../components/Loader";
import {LanguageSwitcher} from '../components/LanguageSwitcher'


const ConfirmPage = () => {

  const navigate = useNavigate()

  const [loading, setLoading] = useState(true);

useEffect(() => {
  const timer = setTimeout(() => {
    setLoading(false);
  }, 3000);

  return () => clearTimeout(timer);
}, []);



if(loading){
  return(
    <>
    <Loader/>
    </>
  )
}







  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {/* Header */}
       <div className={styles.hero}>
  <div className={styles.heroContent}>
    <div className={styles.leftSection}>
      <div className={styles.logoSection}>
        <img
          src="/logo.png"
          alt="UV FoodBox"
          className={styles.logo}
        />

        <div>
          <h2>UV FOODBOX</h2>
        </div>
      </div>

    
    </div>

    <div className={styles.rightSection}>
      <img
        src="/images/aesthetic.png"
        alt="Food"
        className={styles.heroImage}
      />
    </div>
  </div>
</div>

        {/* Content */}
        <div className={styles.content}>
          {/* <CheckCircle size={80} className={styles.successIcon} /> */}

          <h1 className={styles.title}>
            {t('Your purchase has been completed successfully')}!
          </h1>

          {/* <h2 className={styles.subTitle}>
            UVFoodBox Weekly Plan (300 XAF)
          </h2> */}

          <p className={styles.description}>
            {t('Thank you for choosing')} UVFoodBox.
            <br />
            {t('Click the button below to start exploring delicious recipes and cooking inspiration.')}
          </p>

          <button className={styles.ctaButton} onClick={()=>navigate('/')} >
            {t('Click here')}
          </button>
        </div>
      </div>
      <LanguageSwitcher/>
    </div>
  );
};

export default ConfirmPage;